// extracted by mini-css-extract-plugin
export var link = "QuotePageLayout-module--link--cgtAp";
export var activeLink = "QuotePageLayout-module--activeLink--Wsr+4";
export var categories = "QuotePageLayout-module--categories--v90j9";
export var search = "QuotePageLayout-module--search--nOAIE";